import { MatchRepository } from "../repositories/MatchRepository";

export class RejectMatch {
	constructor(private repository: MatchRepository) {}
	execute(match_id: string): Promise<void> {
		return this.repository.rejectMatch(match_id);
	}
}
